var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
activityEvents.forEach(function (e) {
  window.addEventListener(e, functionCustomJS, !1);
});
let flag = false;
function functionCustomJS() {
  if (flag == false) {
    flag = true;
    var script_loaded = !1;
    function loadJSscripts() {
      setTimeout(function () {
        if (!script_loaded) {
          script_loaded = !0;
          var t = document.getElementsByTagName("script");
          for (i = 0; i < t.length; i++)
            null !== t[i].getAttribute("data-src") &&
              (t[i].setAttribute("src", t[i].getAttribute("data-src")),
              delete t[i].dataset.src);
          var e = document.getElementsByTagName("link");
          for (i = 0; i < e.length; i++)
            null !== e[i].getAttribute("data-href") &&
              (e[i].setAttribute("href", e[i].getAttribute("data-href")),
              delete e[i].dataset.href);
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent("StartAsyncLoading")),
              document.dispatchEvent(new CustomEvent("StartKernelLoading"));
          }, 400);
        }
      }, 9e3);
    }
    function loadJSscriptsNow() {
      if (!script_loaded) {
        script_loaded = !0;
        var t = document.getElementsByTagName("script");
        for (i = 0; i < t.length; i++)
          null !== t[i].getAttribute("data-src") &&
            (t[i].setAttribute("src", t[i].getAttribute("data-src")),
            delete t[i].dataset.src);
        var e = document.getElementsByTagName("link");
        for (i = 0; i < e.length; i++)
          null !== e[i].getAttribute("data-href") &&
            (e[i].setAttribute("href", e[i].getAttribute("data-href")),
            delete e[i].dataset.href);
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent("StartAsyncLoading")),
            document.dispatchEvent(new CustomEvent("StartKernelLoading"));
        }, 400);
      }
    }
    var activityEvents = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "keypress",
      "touchmove",
    ];
    activityEvents.forEach(function (t) {
      window.addEventListener(t, loadJSscriptsNow, !1);
    }),
      document.addEventListener("load", loadJSscripts, !1),
      document.addEventListener("onload", loadJSscripts, !1),
      null != window.addEventListener
        ? window.addEventListener("load", loadJSscripts, !1)
        : null != window.attachEvent
        ? window.attachEvent("onload", loadJSscripts)
        : (window.onload = loadJSscripts);
/*
    (function () {
      // Load the script
      const script = document.createElement("script");
      script.src =
        "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
      script.type = "text/javascript";
      script.addEventListener("load", () => {
        var $root = $("html, body");

        $('a[href^="#"]').click(function () {
          var href = $.attr(this, "href");

          $root.animate(
            {
              scrollTop: $(href).offset().top,
            },
            500,
            function () {
              window.location.hash = href;
            }
          );

          return false;
        });
      });
      document.head.appendChild(script);
    })();
    */
  }
}
function removeLazy() {
  var myStringArray = document.querySelectorAll("img.removelazyload");
  var arrayLength = myStringArray.length;
  if (arrayLength > 0) {
    for (var i = 0; i < arrayLength; i++) {
      myStringArray[i].removeAttribute("loading");
    }
  }
}
removeLazy();
window.addEventListener("DOMContentLoaded", (event) => {
  removeLazy();
  setTimeout(removeLazy, 1000);
  setTimeout(removeLazy, 2000);
});
